import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { api } from '../../api/client';
/** Minimal create-form dialog. After creation we navigate to the dedicated
 *  /forms/:id/edit page where every other setting is configured. */
export default function FormCreateDialog({ onCreated, onClose }) {
    const [id, setId] = useState('');
    const [name, setName] = useState('');
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);
    const idOk = /^[a-z0-9][a-z0-9\-]{0,60}$/.test(id);
    async function submit(e) {
        e.preventDefault();
        if (!idOk) {
            setError('ID must be lowercase letters, digits, hyphens');
            return;
        }
        setBusy(true);
        setError(null);
        try {
            await api.createForm({ id, name: name || prettyName(id) });
            onCreated(id);
        }
        catch (err) {
            setError(err?.message ?? 'Create failed');
        }
        finally {
            setBusy(false);
        }
    }
    return (_jsx("div", { className: "modal-backdrop", onClick: onClose, children: _jsxs("div", { className: "modal small-modal", onClick: (e) => e.stopPropagation(), children: [_jsxs("div", { className: "modal-head", children: [_jsx("h3", { children: "New form" }), _jsx("button", { className: "ghost", onClick: onClose, "aria-label": "Close", children: "\u2715" })] }), _jsxs("form", { onSubmit: submit, className: "modal-body", style: { padding: 16 }, children: [_jsxs("label", { className: "field", children: [_jsx("span", { children: "Form ID" }), _jsx("input", { type: "text", autoFocus: true, value: id, onChange: (e) => setId(e.target.value.toLowerCase().replace(/[^a-z0-9\-]/g, '')), placeholder: "contact-us", style: { fontFamily: 'ui-monospace, monospace' } }), _jsxs("span", { className: "muted small", children: ["Used in the embed token ", _jsx("code", { children: `{{form:${id || 'contact-us'}}}` }), ". Can't be renamed later."] })] }), _jsxs("label", { className: "field", children: [_jsx("span", { children: "Display name" }), _jsx("input", { type: "text", value: name, onChange: (e) => setName(e.target.value), placeholder: prettyName(id || 'contact-us') })] }), error && _jsx("div", { className: "err small", children: error }), _jsxs("div", { className: "actions", style: { marginTop: 12 }, children: [_jsx("button", { type: "button", className: "ghost", onClick: onClose, children: "Cancel" }), _jsx("button", { type: "submit", disabled: !idOk || busy, children: busy ? 'Creating…' : 'Create form' })] })] })] }) }));
}
function prettyName(id) {
    return id.split('-').filter(Boolean).map((p) => p.charAt(0).toUpperCase() + p.slice(1)).join(' ') || 'Untitled form';
}
